import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { goToPage, setSelectedSubPackages, setSelectedPackageRoute, setIsSubmit, setErrorPage, clearSelection, reportDWH } from '../PremiumPackagesCatalogSlice';
import { premiumPackageActionAsync, getCatalogAsync } from '../premiumPackagesCatalogAsyncThunk';
import PackageHeader from '../Partials/packageHeader/packageHeader';
import PackagesWord from '../Partials/packagesWord/packagesWord';
import PackagePrice from '../Partials/packagePrice/packagePrice';
import Footer from '../Partials/footer/footer';

const PackagesWorldPage = (props) => {
    const [isCheckedTerms, setIsCheckedTerms] = useState(false);
    const [termsError, setTermsError] = useState('');
    const [error, setError] = useState('');
    console.log(props);
    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            props.reportDWH({ actionType: 'Package Page', status: 'Ongoing', messageText: 'Package Page Displayed' });
            props.clearSelection();
        }
    }, []);

    console.log(props);
    let isDisplayFooter = true;
    let btnText = 'לרכישה';
    let currentPageFunction = handlePageContinue;
    let formid = 'premiumPackagesCatalogForm';

    let purpleTitle = "";
    let boldTitle1 = "";
    let boldTitle2 = "";
    let extraBoldTitle = props.selectedPackage?.cmsData?.selfCare?.title;

    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            {purpleTitle && <h1 className='purple-title'>{purpleTitle}</h1>}
            {boldTitle1 && <h2 className='bold-title1'> {boldTitle1} </h2>}
            {boldTitle2 && <h2 className='bold-title2'> {boldTitle2} </h2>}
            {extraBoldTitle && <h3 className='extra-bold-title'> {extraBoldTitle} </h3>}
        </div>

    );


    let currentPageView = (
        <>
            <PackageHeader selectedPackage={props.selectedPackage} defaultImage={props.defaultImage} />
            <PackagesWord
                defaultImage={props.defaultImage}
                package={props.selectedPackage}
                selectedSubPackages={props.selectedSubPackages}
                onSelectedSubPackage={handleSubmitOnSelectedSubPackage} />
            <PackagePrice isPackagesWorld={true} packages={props.selectedSubPackages} packageWorld={props.selectedPackage} totalPrice={props.totalPrice} isCheckedTerms={isCheckedTerms} termsError={''} onClickTerms={handleOnClickTerms} context={props.context} />
        </>
    )


    return (
        <div>
            {currentPageHeadline}
            <div className='premium-packages-catalog-content'>
                <form noValidate id={formid} onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
                <Footer isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} errorText={error || termsError} formid={formid} />
            </div>
        </div>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }

    function handleOnClickTerms(isChecked) {
        setIsCheckedTerms(isChecked);
        setTermsError('');
    }

    function handleSubmitOnSelectedSubPackage(item, isSelected) {
        setError('');
        if (props.selectedPackage?.cmsData?.isSingleChoice && isSelected && item.action?.toUpperCase() != 'EXISTING') {
            props.selectedSubPackages
                ?.filter(x => x.name != item.name)
                ?.forEach((selectedSubPackage) => {
                    const previousItem = props.selectedPackage?.premiumPackages?.find(x => x.name == selectedSubPackage.name);
                    if (previousItem && previousItem.action?.toUpperCase() != 'EXISTING') {
                        props.setSelectedSubPackages({
                            item: previousItem,
                            isSelected: false,
                            worldName: props.selectedPackage.name,
                            isSingleChoice: props.selectedPackage?.cmsData?.isSingleChoice,
                        });
                    }
                });
        }

        props.setSelectedSubPackages({
            item: item,
            isSelected: isSelected,
            worldName: props.selectedPackage.name,
            isSingleChoice: props.selectedPackage?.cmsData?.isSingleChoice,
        });
        props.getCatalogAsync();
    }

    function handlePageContinue() {
        if (props.selectedSubPackages.length == 0) {
            setError('עליך לבחור לפחות חבילה אחת');
            return;
        }
        if (isCheckedTerms) {
            setTermsError('');
            if (props.selectedSubscriber.hasDebt) {
                props.setErrorPage({ isDisplay: true, id: '0', type: 'hasDebt', isOpenWorkOrder: true, description: 'has debt' });
            }
            else {
                props.premiumPackageActionAsync({ action: "add" });
            }
        }
        else {
            setTermsError('כדי להמשיך יש לאשר את תנאי החבילה');
        }
    }

};

const mapStateToProps = (state) => {
    return {
        selectedSubscriber: state.premiumPackagesCatalog.selectedSubscriber,
        selectedPackage: state.premiumPackagesCatalog.selectedPackage,
        selectedSubPackages: state.premiumPackagesCatalog.subPackages.selected,
        defaultImage: state.premiumPackagesCatalog.epiData?.defaultImage,
        totalPrice: state.premiumPackagesCatalog.totalPrice,
        premiumPackagesCatalog: state.premiumPackagesCatalog
    };
};

const mapDispatchToProps = {
    goToPage,
    setSelectedSubPackages,
    setSelectedPackageRoute,
    setIsSubmit,
    clearSelection,
    setErrorPage,
    premiumPackageActionAsync,
    getCatalogAsync,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PackagesWorldPage);
